<div class="card">
  <div class="header">
    <h4 class="title">{{ title }}</h4>
    <p class="category">{{ subtitle }}</p>
  </div>
  <div class="content">
    <canvas class="chart-canvas" baseChart [data]="chartData" [options]="chartOptions" [type]="chartType">
    </canvas>
  </div>
</div>
